module.exports = __webpack_public_path__ + "static/media/M&M_F1.dde2685e.txt";